import { useState } from "react";
import EnergyHeader from "../../components/energy/energyHeader";
import SideBar from "../../components/UserDashboard/SideBar";
import "../../styles/UserDashboard/EnergyWithdrawalHistory.scss";
import { useSelector } from "react-redux";
import { getWithDrawHistory } from "../../apis/energySharing";
import { useQuery } from "@tanstack/react-query";

export default function EnergyWithdrawalHistory() {
  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);
      const [monthsModal, setMonthsModal] = useState(false);

      const handleMonthsModalClick = () => {
        setMonthsModal(!monthsModal);
      };
    
  // Use react-query for withdrawal history
  const { data, isLoading, error } = useQuery({
    queryKey: ["withdrawHistory", auth?.token],
    queryFn: () => getWithDrawHistory(auth?.token),
    enabled: !!auth?.token,
  });

  // Extract withdrawal items from API response
  const withdrawalItems = data?.data?.data?.items || [];
console.log("withdrawalItems", withdrawalItems);
    
  return (
    <div className="energy-withdrawal-history">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energy-withdrawal-history__inner">
        <EnergyHeader />
        <div className="energy-withdrawal-history__inner__table" id="table">
          <div className="energy-withdrawal-history__inner__table__title-group">
            <div>
            <div className="energy-withdrawal-history__inner__table__title-group__title">
              Recent activities
            </div>
            <div className="energy-withdrawal-history__inner__table__title-group__subtitle">
              <div>In <span>₦250,000</span></div>
              <div>Out <span>₦250,000</span></div>
            </div>
            </div>

            <div
          onClick={handleMonthsModalClick}
          className="energy-withdrawal-history__inner__table__title-group__months"
          >
            <div>June</div>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.16536 5.99967L8.4987 9.33301L11.832 5.99967" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

          </div>

          {monthsModal && 
          <div className="energy-withdrawal-history__inner__table__title-group__months__modal">
            <div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>
              <div>January</div>
            </div>
         
<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>
  <label htmlFor="february-checkbox">February</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="march-checkbox">March</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="april-checkbox">April</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="may-checkbox">May</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="june-checkbox">June</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="july-checkbox">July</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="august-checkbox">August</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="september-checkbox">September</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="october-checkbox">October</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="november-checkbox">November</label>
</div>

<div className="energy-withdrawal-history__inner__table__title-group__months__modal__flex">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"

>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>  <label htmlFor="december-checkbox">December</label>
</div>
          </div>
            } 
          </div>
          <div className="energy-withdrawal-history__inner__table__header-container">
            <div className="energy-withdrawal-history__inner__table__header first">
              Withdrawal
            </div>
            <div className="energy-withdrawal-history__inner__table__header">
              Amount
            </div>
            <div className="energy-withdrawal-history__inner__table__header">
              Transaction ID
            </div>
            <div className="energy-withdrawal-history__inner__table__header">
              Date
            </div>
            <div className="energy-withdrawal-history__inner__table__header last">
              Status
            </div>
          </div>

          {/* Withdrawal history table body */}
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
          ) : error ? (
            <div style={{ textAlign: "center", padding: "20px", color: "red" }}>Error loading withdrawal history</div>
          ) : withdrawalItems.length === 0 ? (
            <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>No withdrawal history found</div>
          ) : (
            withdrawalItems.map((item, idx) => (
              <div key={idx} className="energy-withdrawal-history__inner__table__body">
                <div>{item?.withdrawalTo || "-"}</div>
                <div>₦{item?.amount ? Number(item.amount).toLocaleString() : "-"}</div>
                <div>{item?.transactionId || "-"}</div>
                <div>{item?.date || "-"}</div>
                <div>{item?.status || "-"}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
